import { classNames } from 'shared/lib/classNames/classNames';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { useState } from 'react';
import { APIProductTypes } from 'app/api/APITypes';
import cls from './TabsV1.module.scss';

interface IHistoryTabs {
    name: string,
    value: 'income' | 'outcome' | 'moneybox',
};

interface ITabProps {
    type: 'history' | 'shop',
    callBackFunc: any,
    historyTabs?: IHistoryTabs[],
    shopTabs?: { name: string, filter?: APIProductTypes }[],
}

export const TabsV1 = ({ type, historyTabs, shopTabs, callBackFunc }: ITabProps) => {
    const [ activeTab, setActiveTab ] = useState<number>(0);

    const mappingTabs = {
        history: historyTabs,
        shop: shopTabs,
    };

    return (
        <div className={cls.tabs}>
            {
                //@ts-ignore
                mappingTabs[type].map(({ name, value, filter }, index: number) => {
                    return (
                        <Button
                            className={classNames(cls.tab, {
                                [cls.active]: index === activeTab,
                            })}
                            theme={ButtonTheme.TAB}
                            onClick={() => {
                                setActiveTab(index);
                                callBackFunc(value, filter, index);
                            }}
                            key={index}
                        >
                            {name}
                        </Button>
                    )
                })
            }
        </div>
    );
};
